import { render, staticRenderFns } from "./VFatherProAnamANxAD.vue?vue&type=template&id=fb6a1482"
import script from "./VFatherProAnamANxAD.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamANxAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports